import { $getFormRequestContracts, getFormRequestContracts } from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    getFormRequestContracts,
  },
};

export const $actions = {
  getFormRequestContracts: $getFormRequestContracts,
};
